(function() {
  if (window.CAIconTextSlider) return;

  function init(root) {
    if (!root || root.__itInit) return;
    root.__itInit = true;

    var track = root.querySelector('.it-marquee__track');
    var base = track && track.querySelector('[data-base-group]');
    if (!track || !base) return;

    var speed = Number(root.getAttribute('data-speed')) || 40;
    var direction = root.getAttribute('data-direction') || 'left';
    root.style.setProperty('--it-dir', direction === 'right' ? '1' : '-1');

    var maxClones = 10;
    var resizeTimer = null;

    function cleanupClones() {
      var clones = track.querySelectorAll('[data-it-clone="1"]');
      clones.forEach(function(node) {
        node.remove();
      });
    }

    function ensureClones() {
      var target = root.clientWidth * 2.5 + 120;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var baseWidth = Math.ceil(base.getBoundingClientRect().width);
      if (!baseWidth) return 0;

      cleanupClones();

      var total = baseWidth;
      var count = 0;

      while (total < target && count < maxClones) {
        var clone = base.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-it-clone', '1');
        track.appendChild(clone);
        total += baseWidth + gap;
        count += 1;
      }

      return baseWidth + gap;
    }

    function apply() {
      var loop = ensureClones();
      if (!loop) return;

      var duration = Math.max(loop / speed, 6);
      root.style.setProperty('--it-loop', loop + 'px');
      root.style.setProperty('--it-duration', duration + 's');

      var shouldAnimate = track.scrollWidth > root.clientWidth + 20;
      track.style.animationPlayState = shouldAnimate ? 'running' : 'paused';
      if (!shouldAnimate) {
        track.style.transform = 'translate3d(0,0,0)';
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      }, { threshold: 0.01 });
      io.observe(root);
      root.__itObserver = io;
    }

    var onResize = function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        requestAnimationFrame(apply);
      }, 150);
    };
    window.addEventListener('resize', onResize, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        requestAnimationFrame(apply);
      }).catch(function() {});
    }

    root.querySelectorAll('img').forEach(function(img) {
      if (img.complete) return;
      img.addEventListener('load', function() {
        requestAnimationFrame(apply);
      }, { once: true, passive: true });
      img.addEventListener('error', function() {
        requestAnimationFrame(apply);
      }, { once: true, passive: true });
    });

    requestAnimationFrame(apply);

    root.__itDestroy = function() {
      try {
        window.removeEventListener('resize', onResize);
        if (root.__itObserver) root.__itObserver.disconnect();
      } catch (e) {}
      cleanupClones();
      root.__itInit = false;
      root.__itScheduled = false;
    };
  }

  function scheduleInit(root) {
    if (!root || root.__itInit || root.__itScheduled) return;

    if (window.Shopify && window.Shopify.designMode) {
      init(root);
      return;
    }

    root.__itScheduled = true;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          root.__itInitObserver = null;
          init(root);
        });
      }, { rootMargin: '800px 0px' });
      root.__itInitObserver = observer;
      observer.observe(root);
      return;
    }

    init(root);
  }

  window.CAIconTextSlider = {
    init: init,
    scheduleInit: scheduleInit
  };

  var loader = window.__CA_ICON_TEXT_SLIDER_LOADER__;
  if (loader && loader.queue) {
    loader.queue.splice(0).forEach(init);
  }

  document.querySelectorAll('[data-ca-icon-text-slider]').forEach(scheduleInit);

  if (!window.__CA_ICON_TEXT_SLIDER_EVENTS__) {
    window.__CA_ICON_TEXT_SLIDER_EVENTS__ = true;

    document.addEventListener('shopify:section:load', function(e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ca-icon-text-slider]') : null;
      if (e.target && e.target.matches && e.target.matches('[data-ca-icon-text-slider]')) root = e.target;
      if (root) scheduleInit(root);
    });

    document.addEventListener('shopify:section:unload', function(e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ca-icon-text-slider]') : null;
      if (e.target && e.target.matches && e.target.matches('[data-ca-icon-text-slider]')) root = e.target;
      if (root && root.__itInitObserver) root.__itInitObserver.disconnect();
      if (root && root.__itDestroy) root.__itDestroy();
    });
  }
})();
